module.exports = __webpack_public_path__ + "img/image00007-min.fdd986d5.jpeg";